Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {

    Concerns.tabindexHelpers = {
        onShow: function() {
            this.initTabListener();
        },
        initTabListener: function() {
            var _this = this;
            document.addEventListener('keydown', function(e) {
                _this.highlightTabIndex(e, _this);
            });
            document.addEventListener('mousedown', function(_e) {
                _this.removeHighlightTabIndex(_this);
            });
        },
        highlightTabIndex: function(e, _this) {
            // Need a timeout because without it activeElement is defined as the "old" activeElement
            setTimeout(function() {
                if (e.key === 'Tab') {
                    this.removeHighlightTabIndex(this);
                    var activeElement = $(document.activeElement);
                    var photoBlock = activeElement.closest('.photo_block');
                    if (!_.isFalsy(this.sly) && !_.isFalsy(photoBlock)) {
                        this.sly.activate(photoBlock);
                    }
                    this.lastActiveElement = document.activeElement;
                }
            }.bind(_this), 5);
        },
        removeHighlightTabIndex: function(_this) {
            if (!_.isFalsy(_this.lastActiveElement)) {
                var lastActiveElement = $(_this.lastActiveElement);
                lastActiveElement.attr('tabindex', 0);
                _this.lastActiveElement = false;
            }
        },
        // Helper function which sets accessibility for a list of photos in horizontal, coverflow, vertical widgets
        setAccessibleElements: function() {
            var firstIndex = this.sly.rel.firstItem;
            var lastIndex = this.sly.rel.lastItem;
            var numVisibleElements = lastIndex - firstIndex + 1;
            var photoBlockList = $('.photo_block');
            var visiblePhotoList = photoBlockList.splice(firstIndex, numVisibleElements);

            /* p tags are special - generally non-interactive, but maybe not visible. So they only get aria-hidden
             * attributes. (Off-screen elements are hidden.)
             */
            $(photoBlockList).find('p').each(function() {
                $(this).attr('aria-hidden', 'true');
            });
            $(visiblePhotoList).find('p').each(function() {
                $(this).attr('aria-hidden', 'false');
            });

            // Set interactive off-screen items as unreachable by assistive technologies
            $(photoBlockList).find('[role="button"], a, .img_holder, button, .uploader_tile').each(function() {
                $(this).attr({ 'tabindex': '-1', 'aria-hidden': 'true' });
            });
            // Set all on-screen items as reachable
            $(visiblePhotoList).find('[role="button"], a, .img_holder, button, .uploader_tile').each(function() {
                $(this).attr({ 'tabindex': '0', 'aria-hidden': 'false' });
            });
        }
    };
});
